import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';
declare var bootstrap: any;


@Component({
  selector: 'app-ias-forgotpassword',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './ias-forgotpassword.component.html',
  styleUrl: './ias-forgotpassword.component.scss',
})
export class IasForgotpasswordComponent {
  currentStep = 1;
  emailForm: FormGroup;
  otpForm: FormGroup;
  passwordForm: FormGroup;
  otpControls = ['d1', 'd2', 'd3', 'd4', 'd5', 'd6'];
  showNewPassword = false;
  showConfirmPassword = false;
  token!: string;
  action!: string;
  sessionToken!: string;
  countdown!: number;
  intervalId: any;
  isResendDisabled = false;



  constructor(private fb: FormBuilder, private http: HttpClient) {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email,Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/)]]
    });

    const otpGroup: any = {};
    this.otpControls.forEach(ctrl => {
      otpGroup[ctrl] = ['', Validators.required];
    });
    this.otpForm = this.fb.group(otpGroup);


    this.passwordForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(6), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).+$/)]],
      confirmPassword: ['', [Validators.required]]
    });
  }

  showToast(message: string, type: 'success' | 'error' = 'success') {
    const toastEl = document.getElementById('appToast');
    const toastMsg = document.getElementById('toastMessage');

    if (toastEl && toastMsg) {
      // Set message
      toastMsg.textContent = message;

      // Change background color
      toastEl.classList.remove('text-bg-success', 'text-bg-danger');
      toastEl.classList.add(type === 'success' ? 'text-bg-success' : 'text-bg-danger');

      // Show toast
      const toast = new bootstrap.Toast(toastEl);
      toast.show();
    }
  }


  submitEmail() {
    if (this.emailForm.valid) {
      const payload = { email: this.emailForm.value.email };

      this.http.post<any>(`${environment.apiUrl}/accounts/forgot-password`, payload)
        .subscribe({
          next: (res) => {
            if (res.success) {
              this.token = res.data.token;
              this.action = res.data.action;
              this.currentStep = 2;
              this.startCountdown(59);
              this.showToast('✅ Email sent successfully!', 'success');
            }
          },
          error: (err) => {
            const msg = err.error?.message || '❌ Failed to send email';
            this.showToast(`❌ ${msg}`, 'error');
          }
        });
    }
  }

  onOtpInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    if (input.value && index < this.otpControls.length - 1) {
      const next = input.parentElement?.children[index + 1] as HTMLInputElement | undefined;
      next?.focus();
    }
  }
  startCountdown(seconds: number) {
    this.countdown = seconds;
    this.isResendDisabled = true;

    clearInterval(this.intervalId);
    this.intervalId = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.isResendDisabled = false;
        clearInterval(this.intervalId);
      }
    }, 1000);
  }
  onResendOtp() {
    // 👉 call your API to resend OTP here
    this.submitEmail();
    // this.startCountdown(59);
  }
handleKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    // ✅ allow navigation keys
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (allowedKeys.includes(event.key)) {
      // Handle backspace navigation
      if (event.key === 'Backspace' && !input.value && index > 0) {
        const prev = input.parentElement?.children[index - 1] as HTMLInputElement | undefined;
        prev?.focus();
      }
      return; // allow
    }

    // ✅ block non-digits
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
  submitOtp() {
    if (this.otpForm.valid) {
      const otp = this.otpControls.map(ctrl => this.otpForm.get(ctrl)?.value).join('');
      // console.log('OTP entered:', otp);

      if (!this.token || !this.action) {
        console.error('Token or action not found. Did you call forgot-password first?');
        return;
      }

      const payload = {
        otp: otp,
        action: this.action,
        token: this.token
      };

      this.http.patch<any>(`${environment.apiUrl}/accounts/otpverify`, payload)
        .subscribe({
          next: (res) => {
            if (res.success) {
              this.sessionToken = res.data?.sessionToken;
              this.currentStep = 3;
              this.showToast('✅ OTP verified successfully!', 'success');
            }
          },
        error: (err) => {
          const msg = err.error?.message || '❌ Invalid OTP. Try again.';
          this.showToast(`❌ ${msg}`, 'error');
        }

        });
    }
  }


  togglePassword(field: 'new' | 'confirm') {
    if (field === 'new') {
      this.showNewPassword = !this.showNewPassword;
    } else {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }


  submitPassword() {
    if (this.passwordForm.valid) {
      const password = this.passwordForm.value.newPassword;
      const confirmPassword = this.passwordForm.value.confirmPassword;

      if (password !== confirmPassword) {
        this.showToast('❌ Passwords do not match', 'error');
        return;
      }

      if (!this.sessionToken) {
        console.error('Session token missing. OTP verification must be done first.');
        return;
      }

      const payload = {
        password: password,
        confirmPassword: confirmPassword
      };

      this.http.post<any>(
        `${environment.apiUrl}/accounts/setup-password`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${this.sessionToken}`
          }
        }
      ).subscribe({
        next: (res) => {
          if (res.success) {
            this.currentStep = 4;
            this.showToast('✅ Password set successfully!', 'success');
          }
        },
      error: (err) => {
        const msg = err.error?.message || '❌ Failed to set password';
        this.showToast(`❌ ${msg}`, 'error');
      }
      });
    }
  }

}
